<div class="planTableWrapper" [style.padding]="!isDialog ? '1rem' : 'none'">
    <p id="tableDescription" class="intro">Let's set a plan that meets your needs.</p>
    <a class="link-button learn-more" href="https://www.clarecontrols.com/helpcenter/new-dealer-monitoring-tiers" target="_blank">
        <span>Learn More</span>
        <mat-icon>open_in_new</mat-icon></a
    >
    <div class="tableWrapper">
        <table aria-describedby="tableDescription">
            <tr>
                <th></th>
                <th *ngFor="let plan of availablePlans" class="servicePlanAction" [ngClass]="{ selected: currentPlan?.id === plan.id }">
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="openServicePlanOptions(plan)"
                        [ngStyle]="{ background: getColor(plan) }"
                        class="select-plan-button"
                        [disabled]="currentPlan?.id === plan.id"
                    >
                        Go {{ plan.name }}
                    </button>
                </th>
            </tr>
            <tr *ngFor="let feature of availablePlanFeatures; let even = even" [ngClass]="{ even: even }">
                <td class="rowHeader">{{ feature.featureName }}</td>
                <td *ngFor="let plan of availablePlans" class="checkmark" [ngClass]="{ selected: currentPlan?.id === plan.id }">
                    <div *ngIf="checkFeatures(plan, feature)" [style.color]="getIconColor(plan)">
                        <mat-icon svgIcon="checkmark-new"></mat-icon>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <p class="disclaimerText">
        WiFi or Ethernet connections are required to control all network or cloud-based integrations including, but not limited to, WiFi
        thermostats, Genie/Aladdin devices, etc.
    </p>
</div>
